import Axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'

import { TPostNPSBody, TShowNPS } from 'types/GlobalNPS'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}measurements/nps`

export async function create(body: TPostNPSBody) {
  return Axios.post(URL, { data: body }, parseAuthenticationHeader())
}

export async function getShowNps() {
  const url = `${URL}/show-nps`

  return getWithRedirect<TShowNPS>(url)
}
